import React from 'react';


export const Cloudformation = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/cloudformation.png')} />
    )
};
